module.exports = __webpack_public_path__ + "img/joinDotStraight4.96dbc316.svg";